module.exports = __webpack_public_path__ + "img/image002.ea860c27.png";